import {Component, ElementRef, EventEmitter, Output, ViewChild} from '@angular/core';
import {AppService} from "../../app.service";
import {SegmentAreaDto} from "../../../model/dto";
import {lastValueFrom} from "rxjs";

@Component({
  selector: 'app-tongue-camera',
  templateUrl: './tongue-camera.component.html',
  styleUrl: './tongue-camera.component.scss'
})
export class TongueCameraComponent {
  @Output() onUpload: EventEmitter<File> = new EventEmitter();
  @ViewChild('myCanvas') canvas: ElementRef<HTMLCanvasElement>;

  originalImage: File;
  originalDisplayDataUrl: string;
  croppedImage: File;
  croppedDisplayDataUrl: string;


  constructor(
    private appService: AppService
  ) {
  }

  async uploadPhoto(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    this.originalImage = input.files?.[0];
    const reader = new FileReader();
    reader.onload = (event:any) => {
      this.originalDisplayDataUrl = event.target.result;
    }
    reader.readAsDataURL(this.originalImage);
    this.onUpload.emit(this.originalImage);
  }

  // 1 = inner function, 2 = usana service
  async segment(apiSource: number): Promise<number> {
    if (!this.originalImage) {
      return;
    }
    const compressedResult: {image: File, sizeRatio: number} = await this.compressKeepSize(this.originalImage, 0.1, 500);
    const page = apiSource === 1 ? 'data': 'publicService';
    const token = apiSource === 1 ? null: this.appService.usanaServiceToken;
    const area: SegmentAreaDto = await lastValueFrom(this.appService.postForm(page, 'getTongueArea', {image: compressedResult.image}, token));
    if (area.status !== 1) {
      return area.status;
    }
    // 依照 area.area 裁切圖片
    this.croppedImage = await this.cropImage(this.originalImage, [area.x1, area.y1, area.x2, area.y2], compressedResult.sizeRatio);
    const reader = new FileReader();
    reader.onload = (event:any) => {
      this.croppedDisplayDataUrl = event.target.result;
    }
    reader.readAsDataURL(this.croppedImage);
    return area.status;
  }

  show(): void {
    document.getElementById('FileUploader').click();
  }

  showPhotoCapture(): void {
    document.getElementById('PhotoCapture').click();
  }

  private async compressKeepSize(file: File, quality = 0.1, maxWidth: number): Promise<{image: File, sizeRatio: number}> {
    const img = await this.fileToImage(file);
    let sizeRatio = 1;
    const originalWidth = (img.naturalWidth || img.width);
    const originalHeight = (img.naturalHeight || img.height);
    if (originalWidth > maxWidth) {
      sizeRatio = maxWidth / originalWidth;
    }
    const targetWidth = Math.round(originalWidth * sizeRatio);
    const targetHeight = Math.round(originalHeight * sizeRatio);
    this.canvas.nativeElement.width = targetWidth;
    this.canvas.nativeElement.height = targetHeight;
    const ctx = this.canvas.nativeElement.getContext('2d')!;
    ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
    const blob = await this.canvasToBlob(quality);
    return {
      image: new File([blob], 'photo.jpg', { type: 'image/jpeg', lastModified: Date.now() }),
      sizeRatio: sizeRatio
    };
  }

  fileToImage(file: File): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        // iOS/EXIF 旋轉如有需求可再加處理；此處單純重編碼
        img.src = reader.result as string;
      };
      reader.readAsDataURL(file);
    });
  }

  canvasToBlob(quality: number): Promise<Blob> {
    return new Promise((resolve) => {
      this.canvas.nativeElement.toBlob((b) => resolve(b!), 'image/jpeg', quality);
    });
  }

  private async cropImage(file: File, rect: number[], sizeRatio: number): Promise<File> {
    let [x1, y1, x2, y2] = rect;
    const img = await this.fileToImage(file);
    x1 = Math.floor(x1 / sizeRatio);
    y1 = Math.floor(y1 / sizeRatio);
    x2 = Math.ceil(x2 / sizeRatio);
    y2 = Math.ceil((y2 + 10) / sizeRatio);
    const width = x2 - x1;
    const height = y2 - y1;
    this.canvas.nativeElement.width = width;
    this.canvas.nativeElement.height = height;
    const ctx = this.canvas.nativeElement.getContext('2d')!;
    ctx.drawImage(img, x1, y1, width, height, 0, 0, width, height);
    const blob = await this.canvasToBlob(0.9); // 可調整品質
    return new File([blob], 'cropped.jpg', { type: 'image/jpeg', lastModified: Date.now() });
  }

  clear(): void {
    this.originalImage = null;
    this.originalDisplayDataUrl = null;
    this.croppedImage = null;
    this.croppedDisplayDataUrl = null;
  }
}
